import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessService {
  private toggleState = new BehaviorSubject(null);
  currentState = this.toggleState.asObservable();

  constructor(private messageService: MessageService) {}

  add(mess: {
    severity: string;
    title: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br',
      severity: mess.severity,
      summary: mess.title,
      detail: mess.detail,
      sticky: mess.sticky,
    });
  }

  addError(mess: {
    severity: string;
    title: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br-error',
      severity: mess.severity,
      summary: mess.title,
      detail: mess.detail,
      sticky: mess.sticky,
    });
  }

  clearErrors() {
    this.messageService.clear('br-error');
  }

  changeState(state: any) {
    this.toggleState.next(state);
  }
}
